import "core-js/modules/es.array.index-of";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.keys";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React, { useEffect, useState } from 'react';
import shallow from 'zustand/shallow';
import i18n from '@pureartisan/simple-i18n';
import clsx from 'clsx';
import useStore from './../store';
import { Header, Logo, Canvas, View, CoreButton } from './../../../core';
import SchoolSearch from './../SchoolSearch/SchoolSearch';
import ControlPanel from './../ControlPanel/ControlPanel';
import FeederView from './../FeederView/FeederView';
import MapView from './../MapView/MapView';
import RouteManager from './../RouteManager/RouteManager';
import SlideoutPanel from './../SlideoutPanel/SlideoutPanel';
import IntroModal from './../IntroModal/IntroModal';
import PanelModal from './../PanelModal/PanelModal';
import { ShareLinkModal, UnifiedShareModal } from './../Share';
import Tour from './../Tour/Tour';
import { Tracking } from './../Tracking';
import { ROUTE_SET } from './../../../../constants/metrics';
/**
 * Layout sets up the basic layout for the explorer.
 * @param Object children Child elements
 * @param Object props    Props passed from parent
 */

var Layout = function Layout(_ref) {
  var children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["children"]); // Generic state updates for store.
  // Accepts an object of values to update.


  var setStoreValues = useStore(function (state) {
    return state.setStoreValues;
  }); // Basic props for logo component.

  var logoProps = {
    siteName: i18n.translate("SITE_TITLE"),
    siteHref: useStore(function (state) {
      return state.siteHref;
    }),
    logoSrc: useStore(function (state) {
      return state.logoSrc;
    })
  }; // Active view, map or feeder

  var activeView = useStore(function (state) {
    return state.activeView;
  });
  var handleToggleMenu = useStore(function (state) {
    return state.handleToggleMenu;
  });
  var breakpoint = useStore(function (state) {
    return state.breakpoint;
  });
  var browserWidth = useStore(function (state) {
    return state.browserWidth;
  }); // Handle clicks to any control panel button.

  var handleClick = function handleClick(e) {
    e.preventDefault(); // console.log('Button clicked, ', e.currentTarget.id)

    if (e.currentTarget.id === 'button_toggle_menu') {
      // console.log('toggle menu clicked')
      if (!!handleToggleMenu) {
        handleToggleMenu();
      }
    }
  };

  return /*#__PURE__*/React.createElement("div", _extends({
    className: clsx('layout', 'breakpoint-' + breakpoint)
  }, props), /*#__PURE__*/React.createElement(RouteManager, {
    routeSet: ROUTE_SET
  }), /*#__PURE__*/React.createElement(Tracking, null), /*#__PURE__*/React.createElement(Header, null, /*#__PURE__*/React.createElement(Logo, logoProps), /*#__PURE__*/React.createElement(SchoolSearch, null), /*#__PURE__*/React.createElement(CoreButton, {
    id: "button_toggle_menu",
    "aria-label": i18n.translate("BUTTON_MENU"),
    onClick: handleClick,
    color: "none",
    className: "button-toggle-menu"
  }, /*#__PURE__*/React.createElement("span", {
    className: "menu-icon-group"
  }, /*#__PURE__*/React.createElement("span", {
    className: "menu-icon svg-base"
  }), i18n.translate("BUTTON_MENU")))), /*#__PURE__*/React.createElement("main", null, /*#__PURE__*/React.createElement(Canvas, null, /*#__PURE__*/React.createElement(SlideoutPanel, null), /*#__PURE__*/React.createElement(ControlPanel, null), /*#__PURE__*/React.createElement("div", {
    className: clsx('view-parent', activeView ? 'display-' + activeView : 'display-map')
  }, /*#__PURE__*/React.createElement(MapView, null), /*#__PURE__*/React.createElement(FeederView, null)), /*#__PURE__*/React.createElement(ShareLinkModal, {
    className: "modal-share-link"
  }), /*#__PURE__*/React.createElement(UnifiedShareModal, {
    className: "modal-u-share"
  }), /*#__PURE__*/React.createElement(IntroModal, null), /*#__PURE__*/React.createElement(Tour, null), /*#__PURE__*/React.createElement(PanelModal, null))));
};

export default Layout;